/**
 * Sous-traitants au bureau (B8) : liste et fiche sous « Mon entreprise »,
 * invitation sous la gestion des accès, sous-traitance depuis la fiche
 * d'une intervention. L'API revérifie chaque droit, site compris.
 */
import { lazy } from 'react';
import type { AppRoute } from '../../../app/route-types.js';
import { MISSION_CAPABILITIES, OFFICE_CAPABILITIES } from './office-common.js';

const SubcontractorsPage = lazy(() => import('./SubcontractorsPage.js').then((m) => ({ default: m.SubcontractorsPage })));
const SubcontractorInvitePage = lazy(() => import('./SubcontractorInvitePage.js').then((m) => ({ default: m.SubcontractorInvitePage })));
const SubcontractorRecordPage = lazy(() => import('./SubcontractorRecordPage.js').then((m) => ({ default: m.SubcontractorRecordPage })));
const InterventionSubcontractingPage = lazy(() => import('./InterventionSubcontractingPage.js').then((m) => ({ default: m.InterventionSubcontractingPage })));
const ContributionPreviewPage = lazy(() => import('./ContributionPreviewPage.js').then((m) => ({ default: m.ContributionPreviewPage })));
const GrantMissionPage = lazy(() => import('./GrantMissionPage.js').then((m) => ({ default: m.GrantMissionPage })));

const office = { anyOf: OFFICE_CAPABILITIES };
const missions = { anyOf: MISSION_CAPABILITIES };

export const subcontractorOfficeRoutes: AppRoute[] = [
  { path: '/entreprise/sous-traitants', element: <SubcontractorsPage />, gate: office },
  { path: '/entreprise/sous-traitants/nouveau', element: <SubcontractorInvitePage />, gate: { anyOf: ['users.manage'] } },
  { path: '/entreprise/sous-traitants/:id', element: <SubcontractorRecordPage />, gate: office },
  { path: '/interventions/:id/sous-traitance', element: <InterventionSubcontractingPage />, gate: missions },
  { path: '/interventions/:id/sous-traitance/confier', element: <GrantMissionPage />, gate: missions },
  { path: '/interventions/:id/sous-traitance/:grantId', element: <GrantMissionPage />, gate: missions },
  // Un envoi en entier, relu avant sa reprise (texte, photos, temps, signature).
  { path: '/interventions/:id/sous-traitance/envois/:contributionId', element: <ContributionPreviewPage />, gate: missions },
];
